import { CustomEvents, CustomEventsMap } from 'shared/constants/customEvents'
import { LocalStorageKey } from 'shared/constants/localStorage'

export const dispatchCustomEvent = <K extends CustomEvents>(
  name: K,
  ...args: K extends keyof CustomEventsMap
    ? [CustomEventsMap[K], EventTarget?]
    : []
) => {
  const hasExplicitTarget = args.length === 2
  const target = hasExplicitTarget ? (args[1] as EventTarget) : document
  target.dispatchEvent(new CustomEvent(name, { detail: args[0] }))
}

/** Completes an async system-shortcut action identified by its request ID. */
export const dispatchShortcutActionReady = (
  action: string,
  requestId: string
): void => {
  dispatchCustomEvent(CustomEvents.SHORTCUT_ACTION_READY, {
    action,
    requestId
  })
}

/** Fails an async system-shortcut action identified by its request ID. */
export const dispatchShortcutActionFailed = (
  action: string,
  requestId: string
): void => {
  dispatchCustomEvent(CustomEvents.SHORTCUT_ACTION_FAILED, {
    action,
    requestId
  })
}

export const dispatchStorageEvent = (
  key: LocalStorageKey,
  newValue: string | null
) => {
  window.dispatchEvent(
    new StorageEvent('storage', { key, newValue, storageArea: localStorage })
  )
}

export const listenCustomEvent = <K extends CustomEvents>(
  name: K,
  callback: (
    detail: K extends keyof CustomEventsMap ? CustomEventsMap[K] : never
  ) => void,
  target: EventTarget = document
) => {
  const handler = (event: Event) => {
    const customEvent = event as CustomEvent<
      K extends keyof CustomEventsMap ? CustomEventsMap[K] : never
    >
    callback(customEvent.detail)
  }

  target.addEventListener(name, handler)

  return () => {
    target.removeEventListener(name, handler)
  }
}
